import { useCallback, useState } from 'react';
import I18n from 'I18n';
// @ts-ignore Untyped module
import getNativeCurrencySymbol from 'I18n/utils/getNativeCurrencySymbol';
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'hs-lodash/debounce';
import { CurrencyInput } from 'foundations-components/transitional/components/CurrencyInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import BuyerOverridesActionTypes from '../../state/BuyerOverrides/actionTypes';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { getShowAllErrors } from '../../state/errorMessagesSlice';
import { getLineItemBlurByLineItemId, setLineItemBlur } from '../../state/lineItemBlursSlice';
import { useValidationErrors } from '../../hooks/useValidationErrors';
import useMinMaxAmountsFromValidationErrors from '../../hooks/useMinMaxAmountsFromValidationErrors';
import { jsx as _jsx } from "react/jsx-runtime";
const LineItemPriceOpenAmount = ({
  currencyCode,
  error,
  lineItem
}) => {
  const [openAmountPrice, setOpenAmountPrice] = useState();
  const {
    formState
  } = usePaymentFormContext();
  const dispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const isLineItemBlurred = useSelector(state => getLineItemBlurByLineItemId(state, lineItem.id));
  const isBlurred = isLineItemBlurred || showAllErrors;
  const isError = error && isBlurred;
  const isCheckoutSubmitPending = formState.get('isCheckoutSubmitPending');
  const {
    subtotalsValidationErrors
  } = useValidationErrors();
  const {
    minimumAmount,
    maximumAmount
  } = useMinMaxAmountsFromValidationErrors({
    validationErrors: subtotalsValidationErrors,
    shouldShowAtCheckout: true,
    shouldShowRecurring: true
  });
  const priceConfiguration = lineItem.customConfiguration && lineItem.customConfiguration.priceConfiguration;
  const priceMin = priceConfiguration ? priceConfiguration.min : minimumAmount;
  const priceMax = priceConfiguration ? priceConfiguration.max : maximumAmount;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedDispatchPriceChange = useCallback(debounce(price => {
    dispatch({
      type: BuyerOverridesActionTypes.SET_PRICE,
      data: {
        id: lineItem.id,
        price
      }
    });
  }, 500), [dispatch, lineItem.id]);
  const onPriceChange = useCallback(event => {
    const price = Number(event.target.value) || 0;
    setOpenAmountPrice(price);
    debouncedDispatchPriceChange(price);
  }, [debouncedDispatchPriceChange]);
  const onBlur = useCallback(() => {
    if (!isCheckoutSubmitPending) {
      dispatch(setLineItemBlur({
        lineItemId: lineItem.id,
        isBlurred: true
      }));
    }
  }, [dispatch, lineItem.id, isCheckoutSubmitPending]);
  return /*#__PURE__*/_jsx(FormControl, {
    required: true,
    error: isError,
    children: /*#__PURE__*/_jsx(CurrencyInput, {
      "data-test-id": "line-item-price-open-amount-input",
      readOnly: isCheckoutSubmitPending,
      currency: currencyCode,
      error: isError && !isCheckoutSubmitPending,
      min: priceMin,
      max: priceMax,
      onBlur: onBlur,
      onChange: onPriceChange,
      placeholder: I18n.text('payments.openAmount', {
        currencySymbol: getNativeCurrencySymbol(currencyCode)
      }),
      use: "on-dark",
      value: openAmountPrice
    })
  });
};
export default LineItemPriceOpenAmount;